<template>
  <section>
    <SectionHeading icon="icon-multiple-actions-flight" title="Your fellow explorers" />

    <div class="tribes" :style="{ '--tribes': meetYourTribeItems.length }">
      <div class="tribe" v-for="item in meetYourTribeItems">
        <i class="icon--2xl icon--tertiary" :class="`icon-${item.icon}`"></i>
        <div class="title">{{ item.title }}</div>
        <div class="value">{{ item.value }}</div>
      </div>
    </div>

    <template v-if="guests?.length > 0 && !hideGuests">
      <div class="title">Fellow Travelers</div>

      <div class="guest-count">
        <strong>{{ guests.length }}</strong> total travelers
      </div>

      <div class="guests">
        <div class="guest" v-for="guest in guestList.slice()">
          <img class="photo" :src="guest.photoUrl" />
          <div class="name">{{ guest.firstName }}</div>
        </div>
      </div>

      <button v-if="guests.length > guestLimit" @click="guestLimit = 9999" class="see-more">See more</button>
    </template>
  </section>
</template>

<script setup>
import { useItineraryStore } from '@/stores/itinerary.js'
import SectionHeading from '@/modules/Itinerary/Components/SectionHeading.vue'
import { computed, ref } from 'vue'

const {
  data: {
    itinerary: { meetYourTribeItems, hideGuests },
    guests,
  },
} = useItineraryStore()
const guestLimit = ref(8)
const guestList = computed(() => guests.slice(0, guestLimit.value))
</script>

<style lang="scss" scoped>
section {
  @include flex-column(16px);
}

.title {
  color: $grey-100;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
}

.tribes {
  display: grid;
  grid-template-columns: repeat(min(var(--tribes, 3), 3), auto);
  grid-gap: 16px;
}

.tribe {
  @include flex-column(8px);

  .value {
    font-weight: 400;
  }
}

.guest-count {
  padding: 16px;
  border-radius: 15px;
  border: 1px solid $grey-50;
}

.guests {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 8px;
  row-gap: 12px;
  text-align: center;
}

.guest {
  @include flex-column;
  align-items: center;

  .photo {
    width: 50px;
    aspect-ratio: 1;
    object-fit: cover;
    border-radius: 50%;
  }

  .name {
    word-break: break-all;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
}

.see-more {
  color: $green-300;
  font-weight: 600;
}
</style>
